import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=8f3c5b86&lang=pug&"
import script from "./ActivityView.vue?vue&type=script&lang=ts&"
export * from "./ActivityView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports